// app-toast.component.ts
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef, } from '@angular/material/snack-bar';

export interface AppToastData {
    header: string;
    description: string;
    type: string;
}

@Component({
    selector: 'app-toast',
    standalone: false,
    templateUrl: './app-toast.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppToastComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<AppToastComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: AppToastData
    ) { }

    get messageLines(): string[] {
        if (!this.data.description) {
            return [];
        }

        return this.data.description
            .match(/[^.!?]+[.!?]+|[^.!?]+$/g)
            ?.map((sentence) => sentence.trim())
            .filter(Boolean) ?? [this.data.description];
    }

    // getIcon(): string {
    //     switch (this.data.type) {
    //         case 'success':
    //             return '✓';

    //         case 'error':
    //             return '✕';

    //         case 'warning':
    //             return '!';

    //         case 'info':
    //         default:
    //             return 'i';
    //     }
    // }
}